import CityPageTemplate from "../city-template/CityPageTemplate";
import { arvadaConfig } from "./data";

export default function ArvadaPage() {
  return <CityPageTemplate config={arvadaConfig} />;
}